import { ApiEpBilling, IApiEpBillingFeatureRetrieveReq } from "@smp/api";
import { Await } from "@smp/utils";
import { useQuery, UseQueryOptions } from "react-query";

const KEY = "ep.billing.feature";

export const useEpBillingFeatureList = (options?: {
  useQueryOptions?: Omit<
    UseQueryOptions<Await<ReturnType<typeof ApiEpBilling.Feature.list>>>,
    "queryKey" | "queryFn"
  >;
}) => {
  const { data: featureList, isLoading: isFeatureListLoading } = useQuery(
    [KEY],
    ApiEpBilling.Feature.list,
    options?.useQueryOptions,
  );

  return { featureList, isFeatureListLoading };
};

export const useEpBillingFeature = (options: {
  req: IApiEpBillingFeatureRetrieveReq;
  useQueryOptions?: Omit<
    UseQueryOptions<Await<ReturnType<typeof ApiEpBilling.Feature.retrieve>>>,
    "queryFn" | "queryKey"
  >;
}) => {
  const { data: feature } = useQuery(
    [KEY, options.req],
    () => ApiEpBilling.Feature.retrieve(options.req),
    options.useQueryOptions,
  );

  return { feature };
};
